export interface GuestProfile {
  jobType?: string;
  experienceLevel?: string;
  industry?: string;
}

/**
 * sessionStorage の guestProfile JSON をパースし、各キーの型を検証する。
 * 無効なデータの場合は null を返す。
 */
export function parseGuestProfile(raw: string | null): GuestProfile | null {
  if (!raw) return null;

  try {
    const parsed: unknown = JSON.parse(raw);

    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
      return null;
    }

    const obj = parsed as Record<string, unknown>;

    // 旧形式（experienceYears のみ）は無効とみなす
    if (obj.experienceYears && !obj.experienceLevel) return null;

    const result: GuestProfile = {};

    if (typeof obj.jobType === "string") result.jobType = obj.jobType;
    if (typeof obj.experienceLevel === "string") result.experienceLevel = obj.experienceLevel;
    if (typeof obj.industry === "string") result.industry = obj.industry;

    // 有効なキーが1つもなければ null を返す
    if (Object.keys(result).length === 0) return null;

    return result;
  } catch {
    return null;
  }
}
